import {convertPxToRem} from '@pb/kit-util-convert-px-to-rem';

import MultiColor from './icons-multi-color-generated';
import SingleColor from './icons-single-color-generated';

export const Icons = {
    ...SingleColor,
    ...MultiColor,
} as const;
export const Sizes = {
    Size_8: 'Size_8',
    Size_10: 'Size_10',
    Size_12: 'Size_12',
    Size_14: 'Size_14',
    Size_16: 'Size_16',
    Size_19: 'Size_19',
    Size_24: 'Size_24',
    Size_28: 'Size_28',
    Size_32: 'Size_32',
} as const;
export const SIZES_TYPES = {
    [Sizes.Size_8]: convertPxToRem(8),
    [Sizes.Size_10]: convertPxToRem(10),
    [Sizes.Size_12]: convertPxToRem(12),
    [Sizes.Size_14]: convertPxToRem(14),
    [Sizes.Size_16]: convertPxToRem(16),
    [Sizes.Size_19]: convertPxToRem(19),
    [Sizes.Size_24]: convertPxToRem(24),
    [Sizes.Size_28]: convertPxToRem(28),
    [Sizes.Size_32]: convertPxToRem(32),
} as const;

export type IconType = typeof SingleColor[keyof typeof SingleColor] | typeof MultiColor[keyof typeof MultiColor];
export type IconSize = keyof typeof Sizes;
